
import moment from 'moment'
import { mapState } from 'vuex'

import SingleProduct from './SingleProduct'
import Icon from './Icon'

export default {
  name: 'SingleCategory',
  components: {
    SingleProduct,
    Icon,
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    placement: {
      type: String,
      default: 'menu',
      validator: (value) => {
        return ['menu', 'catering', 'order'].includes(value)
      }
    },
    index: {
      type: Number,
      default: 0,
    },
    config: {
      type: Object,
      default: () => {
        return {
          seeAllArrow: {
            // minimumAmountOfProducts: 5,
            name: 'See All',
            iconName: 'chevron-right-icon',
            iconClass: 'large white',
          },
          showAvailableDescription: false,
          navigationArrows: {
            leftIconName: 'chevron-left-icon',
            leftIconClass: 'large white',
            rightIconName: 'chevron-right-icon',
            rightIconClass: 'large white',
          },
          hideUnavailableProducts: false,
        }
      }
    }
  },
  data() {
    return {
      scroll: 0,
      fullWidth: 0,
      cardWidth: 0,
      barTranslate: 0,
      barFullWidth: 0,
    }
  },
  mounted() {
    this.scrollToElement();
    setTimeout(() => {
      const $cat = document.getElementById(this.catScrollId)
      if ($cat) {
        this.fullWidth = $cat.scrollWidth
        if ($cat.children && $cat.children.length > 0) {
          this.cardWidth = $cat.children[0].offsetWidth
        }
      }
    }, 500)
    setTimeout(() => {
      const $menu = document.getElementById(this.catBarId)
      if ($menu) {
        this.barFullWidth = $menu.offsetWidth
      }
    }, 2000)
  },
  computed: {
    ...mapState([ 'location', 'appInfo' ]),
    isMobile() {
      return this.$mq == 'sm' || this.$mq == 'md' ? true : false
    },
    catId() {
      if (this.data && this.data.name) {
        return this.$utils.kebab(this.data.name)
      }

      return null
    },
    catScrollId() {
      return this.catId + '-products'
    },
    catBarId() {
      return this.catId + '-bar'
    },
    innerWidth() {
      try {
        if (!window) {
          return this.cardWidth
        }
      } catch (error) {
        return this.cardWidth
      }
      return window.innerWidth
    },
    showNavigation() {
      if (this.fullWidth > this.innerWidth) {
        return true
      }
      return false
    },
    bullets() {
      return Math.ceil(this.fullWidth / this.innerWidth)
    },
    barWidth() {
      const tabs = Math.ceil(this.fullWidth / this.barFullWidth)
      return this.barFullWidth / tabs
    },
    showSeeAllButton() {
      if (this.config?.seeAllArrow) {

        // Checks for a minimum amount of products to display the See All button
        if (this.config.seeAllArrow?.minimumAmountOfProducts) {
          if (this.data.products.length < this.config.seeAllArrow.minimumAmountOfProducts) {
            return false
          }
        }

        // Checks for a name
        if (this.config.seeAllArrow.name) {
          return true
        }

        // Checks for an icon
        if (this.config.seeAllArrow.iconName) {
          return true
        }
      }

      return false
    },

    nowTimeAtLocation() {
      let loc = this.location
      const localUtcOffset = moment().utcOffset() / 60
      const locationUtcOffset = loc.utcoffset || loc.utcOffset
      const absoluteLocalUtcOffset = Math.abs(localUtcOffset)
      const absoluteLocationUtcOffset = Math.abs(locationUtcOffset)
      const difference = Math.abs(localUtcOffset - locationUtcOffset)

      let now = moment()
      if (absoluteLocalUtcOffset < absoluteLocationUtcOffset) {
        // local time is ahead
        now = moment().subtract(difference, 'hours')
      } else if (absoluteLocalUtcOffset > absoluteLocationUtcOffset) {
        // local time is behind
        now = moment().add(difference, 'hours')
      }

      return now
    },
  },
  methods: {
    leftScroll() {
      document.getElementById(this.catScrollId).scrollLeft += -this.innerWidth
      if ((this.barTranslate - this.barWidth) <= 0) {
        this.barTranslate = 0
      } else {
        this.barTranslate += -this.barWidth
      }
    },
    rightScroll() {
      document.getElementById(this.catScrollId).scrollLeft += this.innerWidth
      if ((this.barTranslate + this.barWidth) >= this.barFullWidth) {
        this.barTranslate = this.barFullWidth - this.barWidth
      } else {
        this.barTranslate += this.barWidth
      }
    },
    bulletScroll(idx) {
      document.getElementById(this.catScrollId).scrollLeft = (idx - 1) * this.innerWidth
      this.barTranslate = (idx - 1) * this.barWidth
    },
    getScroll() {
      const $catScrollID = document.getElementById(this.catScrollId)
      if ($catScrollID) {
        this.scroll = $catScrollID.scrollLeft
        if (this.isMobile) {
          const offset = 20
          const scrollCalc = (this.scroll * this.innerWidth) / this.fullWidth
          if (scrollCalc <= offset) {
            this.barTranslate = 0
          } else if (scrollCalc >= (this.barFullWidth - this.barWidth - offset)) {
            this.barTranslate = this.barFullWidth - this.barWidth
          } else {
            this.barTranslate = scrollCalc
          }
        }
      }
    },
    isActiveBullet(idx) {
      return Math.ceil(this.scroll / this.innerWidth) === (idx - 1)
    },
    scrollToElement() {
      const urlParams = new URLSearchParams(window.location.search)
      if (!urlParams.has('category')) return
      const elementId = urlParams.get('category')
      const $element = document.getElementById(elementId)
      if (!$element) return
      setTimeout(() => $element.scrollIntoView({
        behavior: this.appInfo?.menu?.scroll_behaviour || 'smooth',
      }), 1000)
    },
    seeAll() {
      const index = this.data.id || this.index
      this.$router.push(`/${this.placement}/${this.location.menu_id}/category/${index}`)
    },
    isAvailable(prod) {
      const now = this.nowTimeAtLocation
      const availableFrom = moment(prod?.availability.start).format()
      const availableTo = moment(prod?.availability.end).format()

      if (moment(now).isSameOrAfter(availableFrom) || moment(now).isSameOrBefore(availableTo) || prod?.availability.now) {
        return true
      }
      return false
    }
  },
}
